import SprintList from '../components/sprint/SprintList';

import { PageTitle } from '../../../../_metronic/layout/core';

export default function SprintsPage() {
  return (
    <>
      <PageTitle>DevOps - Sprints</PageTitle>
      <SprintList />
    </>
  );
}
